import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewLstSanidad = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'lst_sanidad', 
        name: 'Analisis de Sanidad', 
        component: ViewLstSanidad,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
